import { io } from "socket.io-client";

const BASE = process.env.REACT_APP_API_URL || "http://localhost:4000";

let socket = null;

export function getSocket(token) {
  if (!socket) {
    socket = io(BASE, {
      auth: { token },
      autoConnect: true,
      reconnectionAttempts: 10,
    });
  }
  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }
}
